import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import logo from 'assets/images/social-play-white.png';
import Styles from 'views/register/Register.module.scss';

const LoginLeftSection: FunctionComponent = () => (
  <>
    <Link to="/" className={Styles.logoLink}>
      <img src={logo} alt="logo" className={`img-fluid ${Styles.logoImage}`} />
    </Link>
    <p className={`${Styles.descriptionLine} text-white`}>Audio and Video chat with people nearby.</p>
  </>
);

export default LoginLeftSection;
